var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isNode
    ? _c("html", [
        _c("head", [
          _c("title", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("meta", { attrs: { name: "keywords", content: _vm.keywords } }),
          _vm._v(" "),
          _c("meta", {
            attrs: { name: "description", content: _vm.description }
          }),
          _vm._v(" "),
          _c("meta", {
            attrs: {
              "http-equiv": "content-type",
              content: "text/html;charset=utf-8"
            }
          }),
          _vm._v(" "),
          _c("meta", {
            attrs: {
              name: "viewport",
              content: "initial-scale=1, maximum-scale=1, user-scalable=no"
            }
          }),
          _vm._v(" "),
          _c("link", {
            attrs: {
              rel: "shortcut icon",
              href: "/league/favicon.ico",
              type: "image/x-icon"
            }
          })
        ]),
        _vm._v(" "),
        _c("body", [
          _c("div", { attrs: { id: "app" } }, [_vm._t("default")], 2)
        ])
      ])
    : !_vm.isNode
    ? _c("div", { attrs: { id: "app" } }, [_vm._t("default")], 2)
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }